export const SITE_URL = 'https://qr-code.pixelutility.com';
export const PIXELUTILITY_URL = 'https://pixelutility.com';
export const SUPPORT_URL = 'https://pixelutility.com/support';

/** Google AdSense publisher ID */
export const ADSENSE_CLIENT = 'ca-pub-4958360574877314';

/** Google Analytics 4 measurement ID */
export const GA_MEASUREMENT_ID = 'G-V0PCF4TC66';

export const SITE_NAME = 'PixelUtility QR';
export const OG_IMAGE_URL = `${SITE_URL}/og-image.png`;
export const OG_IMAGE_WIDTH = 1200;
export const OG_IMAGE_HEIGHT = 630;
export const LOCALE = 'en_US';

export const DEFAULT_META = {
  title: 'Free QR Code Generator – No Redirects | PixelUtility',
  description:
    'Generate free QR codes instantly with no redirects, no tracking pages, and no sign-up. Create URL, WiFi, vCard, SMS, and call QR codes. Download PNG or SVG in your browser.',
  keywords:
    'free qr code generator, qr code maker, no redirect qr code, wifi qr code, vcard qr code, sms qr code, png qr code, svg qr code, pixelutility',
};
